module.exports = __webpack_public_path__ + "img/benin.37921078.png";